import React from 'react';
import { CURRENCIES } from './currency';
export const CurrencyComponent = (props) => {
    const { iso, value, minimumFractionDigits, maximumFractionDigits, alignSymbolToRight, showCOPCurrencySymbol } = props;
    const formatOptions = CURRENCIES[iso] || CURRENCIES.COP;
    // TODO: Create a object called currencyProperties
    let currencyCodeSymbol = '';
    if (iso === 'COP' && showCOPCurrencySymbol) {
        currencyCodeSymbol = `${formatOptions.symbol} `;
    }
    if (iso === 'BRL')
        currencyCodeSymbol = `${formatOptions.symbol} `;
    const formatter = new Intl.NumberFormat(formatOptions.locales, Object.assign({ style: 'currency', currency: iso, maximumFractionDigits,
        minimumFractionDigits }, formatOptions));
    const formattedValue = formatter.format(value);
    const containSymbol = formattedValue.includes(formatOptions.symbol) || formattedValue.includes(iso);
    const formatAmount = () => {
        const amountValue = formattedValue
            .replace(iso, '')
            .replace(formatOptions.symbol, '');
        return (React.createElement(React.Fragment, null, alignSymbolToRight ? `${currencyCodeSymbol}${amountValue.trim()} ${iso}` : `${currencyCodeSymbol} ${amountValue.trim()}`));
    };
    if (!containSymbol)
        return React.createElement(React.Fragment, null, formattedValue);
    return formatAmount();
};
//# sourceMappingURL=index.js.map